import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-combined-user-devices',
  templateUrl: './combined-user-devices.component.html',
  styleUrls: ['./combined-user-devices.component.css']
})
export class CombinedUserDevicesComponent implements OnInit {
  switchServiceForm!: FormGroup;
  selectedServiceType: string = 'User';

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private route: ActivatedRoute
  ) {}

  ngOnInit() {
    this.switchServiceForm = this.fb.group({
      switchServiceType: [this.selectedServiceType, Validators.required],
    });
  
    this.route.params.subscribe((params) => {
      const serviceType = params['serviceType'];
      if (serviceType) {
        this.selectedServiceType = serviceType;
        this.switchServiceForm.patchValue({ switchServiceType: serviceType });
      } else {
        this.router.navigate(['/services', 'users']);
      }
    });
  }
  

  switchService() {
    const currentServiceType = this.switchServiceForm.value.switchServiceType;

    if (currentServiceType !== this.selectedServiceType) {
      this.selectedServiceType = currentServiceType;
      this.router.navigate(['/services', this.selectedServiceType]);
    }
  }
}
